'use es6';

import reportFiltersExtractor from '../retrieve/inboundDb/common/extractors/reportFilters';
export default (config => reportFiltersExtractor()(config));